<p>klassendashboard-individueel-table-totaal-row works!</p>
